<footer class="site-footer" role="contentinfo">
  <div class="site-footer__container">
    <div class="site-footer__pre-footer">
      <div class="row site-footer__pre-footer-row">
        <div class="col-12 col-md-9">
          <nav aria-label="Footer - Services" class="site-footer__services">
            <div class="row">
              <ul class="site-footer__menu col-12 col-md-6">
                <li *ngFor="let link of servicesFirst"><a [href]="baseUrl + link.path">{{ link.label }}</a></li>
              </ul>
              <ul class="site-footer__menu col-12 col-md-6">
                <li *ngFor="let link of servicesSecond"><a [href]="baseUrl + link.path">{{ link.label }}</a></li>
              </ul>
            </div>
          </nav>
        </div>
        <div class="col-12 col-md-3">
          <nav aria-label="Footer - Tasks">
            <ul class="site-footer__menu site-footer__menu--tasks">
              <li *ngFor="let link of tasks"><a [href]="baseUrl + link.path">{{ link.label }}</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div class="site-footer__post-footer">
      <div class="row align-items-center">
        <div class="col-12 col-md-9">
          <nav aria-label="Footer - Info links">
            <ul class="site-footer__menu site-footer__menu--info-links">
              <li *ngFor="let link of infoLinks"><a [href]="baseUrl + link.path">{{ link.label }}</a></li>
            </ul>
          </nav>
        </div>
        <div class="col-12 col-md-3">
          <ul class="site-footer__social">
            <li *ngFor="let link of social">
              <a [href]="link.url"><img width="32" height="32" [src]="link.icon" [alt]="link.label" /></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
